import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import AboutPartsAvatarContainer from "container/about-partsavatar/about-partsavatar.container";

function AboutPartsavataCanada(props: IGenericCmsPage) {
  return <AboutPartsAvatarContainer {...props} />;
}

export default AboutPartsavataCanada;
